import './style.scss';

import { Button } from 'antd';
import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

const NormalButton = props => (
  <Button
    className={classNames('button-wrapper', props.className)}
    danger={props.isDanger}
    type={props.type}
    icon={props.icon}
    ghost={props.ghost}
    disabled={props.disabled}
    loading={props.loading}
    onClick={props.onClick}
    htmlType={props.htmlType}
  >
    {props.text}
    {' '}
    {props.suffix}
  </Button>

);

NormalButton.defaultProps = {
  className: '',
  type: '',
  ghost: false,
  disabled: false,
  loading: false,
  icon: undefined,
  text: '',
  isDanger: false,
  htmlType: '',
  suffix: undefined,

  onClick: () => {},
};

NormalButton.propTypes = {
  className: PropTypes.string,
  type: PropTypes.string,
  ghost: PropTypes.bool,
  disabled: PropTypes.bool,
  loading: PropTypes.bool,
  icon: PropTypes.node,
  text: PropTypes.string,
  isDanger: PropTypes.bool,
  htmlType: PropTypes.string,
  suffix: PropTypes.node,

  onClick: PropTypes.func,
};

export default NormalButton;
